class WardrobeSizeChart extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const dialog = this.querySelector('dialog');
    const template = this.querySelector('template');
    const source = template?.content.querySelector('[data-wardrobe-size-content]');
    if (!dialog || !source) return;
    const content = source.cloneNode(true);
    content.querySelectorAll(':scope > p').forEach((p, i) => { if (i < 2) p.remove(); });
    dialog.querySelector('[data-chart-body]').append(content);
    if (!content.querySelector('[data-size-unit]')) dialog.querySelector('.bsh-modal-units')?.remove();
    const setUnit = unit => {
      dialog.querySelectorAll('[data-size-unit]').forEach(panel => {
        panel.open = panel.dataset.sizeUnit === unit;
        panel.hidden = panel.dataset.sizeUnit !== unit;
        panel.removeAttribute('name');
      });
      dialog.querySelectorAll('[data-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === unit)));
    };
    this.querySelector('[data-chart-open]').addEventListener('click', () => {
      setUnit(this.dataset.country === 'US' ? 'in' : 'cm');
      dialog.showModal();
    });
    dialog.querySelector('[data-chart-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      const button = event.target.closest('[data-unit]');
      if (button) setUnit(button.dataset.unit);
    });
  }
}
if (!customElements.get('wardrobe-size-chart')) customElements.define('wardrobe-size-chart', WardrobeSizeChart);
